import React from 'react';

/**
 * Minimalist line icons for the auth screens (LoginV2 / GpLoginV2).
 * Stroke-based, inherit `currentColor`, 1.6 weight — replaces the heavier @ohif filled icons.
 */
type IconProps = { size?: number };

const svg = (size: number) => ({
  width: size,
  height: size,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
});

export const MailIcon: React.FC<IconProps> = ({ size = 18 }) => (
  <svg {...svg(size)}>
    <rect
      x="3"
      y="5"
      width="18"
      height="14"
      rx="2"
    />
    <path d="m3 7 9 6 9-6" />
  </svg>
);

export const LockIcon: React.FC<IconProps> = ({ size = 18 }) => (
  <svg {...svg(size)}>
    <rect
      x="4"
      y="10.5"
      width="16"
      height="9.5"
      rx="2"
    />
    <path d="M8 10.5V7a4 4 0 0 1 8 0v3.5" />
  </svg>
);

export const ClinicIcon: React.FC<IconProps> = ({ size = 18 }) => (
  <svg {...svg(size)}>
    <path d="M3 21h18" />
    <path d="M5 21V5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v16" />
    <path d="M15 8h3a1 1 0 0 1 1 1v12" />
    <path d="M10 8v3M8.5 9.5h3" />
  </svg>
);

export const EyeIcon: React.FC<IconProps> = ({ size = 18 }) => (
  <svg {...svg(size)}>
    <path d="M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7-10-7-10-7Z" />
    <circle
      cx="12"
      cy="12"
      r="3"
    />
  </svg>
);

export const EyeOffIcon: React.FC<IconProps> = ({ size = 18 }) => (
  <svg {...svg(size)}>
    <path d="M3 3l18 18" />
    <path d="M10.6 5.1A11 11 0 0 1 12 5c6.5 0 10 7 10 7a18.5 18.5 0 0 1-3.2 3.9" />
    <path d="M6.6 6.6A18.5 18.5 0 0 0 2 12s3.5 7 10 7a11 11 0 0 0 4-.7" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
  </svg>
);
